import * as React from 'react'
import Socket from '../../../Socket/socket-init'
import * as Utils from '../../../Logic/Utils'
// import { Logic } from '../../../Logic/Type'
// import { Main } from '../../../Logic/Main'
import * as Assets from '../../../assets/Assets'
import * as Body from './Body'
import { Link, Redirect, withRouter } from 'react-router-dom'
import { Cookies, withCookies } from 'react-cookie'
import * as moment from 'moment'
import Loader from './Loader'

interface IProps {
    userDropdown: boolean
    leaderboardTypeClicked: number
    leaderboardRoundClicked: number
    listen: boolean
    chosenPlayer: number
    latestRound: number
    mobileMenu: boolean
    roundsDropdown: boolean
    chosenRound: string
    popup: boolean
    numOfPages: number
    selectedPage: number
}

export class Leaderboards extends React.Component<{history: any}, IProps> {

    public cookies
    
    constructor(props) {
        super(props)

        window.scroll(0, 0)

        this.props.history.push('/leaderboards')

        this.cookies = new Cookies()

        this.state = {
            userDropdown: false,
            leaderboardTypeClicked: 1,
            leaderboardRoundClicked: null,
            listen: false,
            chosenPlayer: null,
            latestRound: null,
            mobileMenu: false,
            roundsDropdown: false,
            chosenRound: 'OVERALL',
            popup: false,
            numOfPages: 1,
            selectedPage: 1
        }

        Socket.Send('rounds', {playerId: +this.cookies.get('playerId')})
        Socket.Send('leaderboards', {playerId: +this.cookies.get('playerId'), tab: 1, league: +localStorage.getItem('leagueId')})
    }

    componentWillReceiveProps() {
        if (this.state.listen === true) {                
          const rounds = Socket.Get<any>('rounds')
          if (rounds.loading === 'loaded') {
            this.setState({
              listen: false
            })

            const currentTime = moment.utc()
            const competitionRounds: any[] = []
            if (!this.state.leaderboardRoundClicked) {
                for (let i = 0; i < rounds.rounds.length; i++) {
                    const utcDeadline = moment.utc(rounds.rounds[i].deadline)
                    if (rounds.rounds[i].played && currentTime.isAfter(utcDeadline)) competitionRounds.push(rounds.rounds[i])
                }

                const latestRound = Math.max.apply(Math, competitionRounds.map(function(x) { return x.roundId }))
                this.setState({ latestRound })
                Socket.Send('results', {playerId: this.state.chosenPlayer, round: latestRound})
            } else {
                this.setState({ latestRound: this.state.leaderboardRoundClicked })
                Socket.Send('results', {playerId: this.state.chosenPlayer, round: this.state.leaderboardRoundClicked})
            }
          }
        }

        const leaderboards = Socket.Get<any>('leaderboards')
        if (leaderboards.loading === 'loaded') {
            const lb = leaderboards.leaderboards.leaderboard
            if (lb) {
                const numOfPages: number = Math.ceil(lb.length / 10)
                this.setState({ numOfPages })
            }
        }
    }

    render() {
        if (this.state.latestRound !== null) {
            return <Redirect to={{ pathname:'/results', state: { playerId: this.state.chosenPlayer, resultsRound: this.state.latestRound } }}/>
        }
        const leaderboards = Socket.Get<any>('leaderboards')
        const rounds = Socket.Get<any>('rounds')
        if (leaderboards.loading !== 'loaded' || rounds.loading !== 'loaded') {
            return <Loader/>
        } else {
            return(
                <div>
                    <section className="wrapper">
                        <div className="header" role="banner">
                            <header className="navbar navbar-default" style={{ marginBottom: '0' }}>
                                <div className="container">
                                    <div className="navbar-header">
                                        <button 
                                            onClick={() => this.setState({ mobileMenu: !this.state.mobileMenu })}
                                            type="button" 
                                            className={(this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed'} 
                                            data-toggle="collapse" 
                                            data-target="#navbar-collapse-mid" 
                                            aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                        >
                                        <span className="sr-only">Toggle navigation</span>
                                        <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                        <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                        <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                        </button>                                  
                                        <Link className="navbar-brand" to="/">
                                        <img src={Assets.logoMain} alt="" className="logo" />
                                        </Link> 
                                        <span className="navbar-toggle user-profile-trigger">{this.cookies.get('username')}</span>
                                    </div>
                                    <nav 
                                        className={(this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse'} 
                                        id="navbar-collapse-left"
                                        aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                        style={(this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' }}
                                    >
                                        {(this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)}
                                    </nav>
                                    <nav className="collapse navbar-collapse" id="user-profile">
                                        <ul className="nav navbar-nav navbar-right">
                                            <li className="user-nav-option">
                                                <div className="user">
                                                    <div className="user-info-wrap"> <span className="user-name">{this.cookies.get('username')}</span>
                                                        <div className="balance-info"> Balance<span className="text-primary">5,000 € </span>
                                                            <a href="javascript:void(0);"><i className="icon-plus-circular"/></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            {(this.cookies.get('username')) ? 
                                            <li className={(this.state.userDropdown === true) ? 'dropdown open' : 'dropdown'}>
                                                <a href="javascript:void(0);" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded={(this.state.userDropdown) ? 'true' : 'false'}>
                                                    <i className="icon-menu-dots" onClick={() => this.setState({userDropdown: !this.state.userDropdown})}/>
                                                </a>
                                                <ul className="dropdown-menu">
                                                        <li><Link to="/myprofile"><i className="icon-profile"/>MY PROFILE</Link></li>
                                                        <li onClick={() => Utils.logout()}>
                                                        <Link to="/login">
                                                            <i className="icon-logout"/>
                                                            LOGOUT
                                                        </Link>
                                                        </li>
                                                </ul>
                                            </li>
                                            :
                                            null}
                                        </ul>
                                    </nav>
                                </div>
                            </header>
                        </div>
                        <div className="info-ribbon">
                            <div className="container">
                                <div className="h4 text-center">RANKINGS</div>
                            </div>
                        </div>
                        <main className="main">
                            <div className="container">
                                <div className="panel panel-default">
                                    <div className="panel-body">
                                        <div className="panel-icon">
                                            <i className="icon-trophy"/>
                                        </div>
                                        <div className="clearfix"/>
                                        <div className="text-center ">
                                            <div className="clearfix mT20"/>
                                            <div className="h3 font-size-30">
                                            {(localStorage.getItem('leaderboardLeagueName'))
                                            ? localStorage.getItem('leaderboardLeagueName')
                                            : 'Overall Ranking'}
                                            </div>
                                            {(localStorage.getItem('leaderboardLeagueName')) ?
                                                <div className="leaderboards-invite">
                                                    <span onClick={() => this.setState({ popup: true })}>INVITE</span>
                                                </div>
                                            : null}
                                        </div>
                                        {/*<div className="clearfix mT20"/>
                                        {(this.props.location.state.overallRanking === true) ? 
                                        <div className="leaderboard-type">
                                            <span className="leaderboard-type-title"><b>Leaderboard type: </b></span>
                                            <a onClick={() => this.changeType(null, 1)} className={(this.state.leaderboardTypeClicked === 1) ? 'leaderboard-type-round' : null}><span >Global</span></a>
                                            <a onClick={() => this.changeType(null, 2)} className={(this.state.leaderboardTypeClicked === 2) ? 'leaderboard-type-round' : null}><span>National</span></a>
                                            
                                        </div>
                                        : null}
                                        <div className="leaderboard-type">
                                            <span className="leaderboard-type-title"><b>Rounds: </b></span>
                                            {this.getRoundsNames()}
                                        </div>*/}
                                        <div className="data-list-table limited-width">
                                            <div className="page-header border-light outer-header mTzero h5">
                                                <div className="row">
                                                    <div className="col-sm-4 right leaderboards-header-50">
                                                        <div className="row">
                                                            <div className="col-xs-4 leaderboard-round">
                                                                <label style={{ fontWeight: 'normal' }}>Round</label>
                                                            </div>
                                                            <div className="col-xs-8">
                                                                <span onClick={() => this.setState({ roundsDropdown: !this.state.roundsDropdown })} className={(this.state.roundsDropdown) ? 'leaderboards-round-selection select2 select2-container select2-container--default select2-container--below select2-container--focus select2-container--open' : 'leaderboards-round-selection select2 select2-container select2-container--default select2-container--below select2-container--focus'} dir="ltr">
                                                                    <span className="selection">
                                                                        <span className="select2-selection select2-selection--single" role="combobox" aria-haspopup="true" aria-expanded={(this.state.roundsDropdown) ? 'true' : 'false'} aria-labelledby="select2--cy-container" aria-owns={(this.state.roundsDropdown) ? 'select2--cy-results' : null}>
                                                                            <span className="select2-selection__rendered" id="select2--cy-container" title="MD 1">{this.state.chosenRound}</span>
                                                                            <span className="select2-selection__arrow" role="presentation">
                                                                                <b role="presentation"/>
                                                                            </span>
                                                                        </span>
                                                                    </span>
                                                                    <span className="dropdown-wrapper" aria-hidden="true"/>
                                                                </span>
                                                                {(this.state.roundsDropdown) ?
                                                                <span className="select2-container select2-container--default select2-container--open">
                                                                    <span className="select2-dropdown select2-dropdown--below leaderboards-rounds-dropdown results-round-selection" style={{ display: 'inline-block' }} dir="ltr">
                                                                        <span className="select2-search select2-search--dropdown select2-search--hide">
                                                                            <input className="select2-search__field" type="search" role="textbox"/>
                                                                        </span>
                                                                        <span className="select2-results">
                                                                            <ul className="select2-results__options" role="tree" id="select2--cy-results" aria-expanded="true" aria-hidden="false">
                                                                                {this.getRoundsNames()}
                                                                            </ul>
                                                                        </span>
                                                                    </span>
                                                                </span>
                                                                : null}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <span className="user-info"><b>User Info</b></span>
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>RANK</th>
                                                        <th className="username">USERNAME</th>
                                                        <th className="leaderboard-stats-hide">CORRECT SCORES</th>
                                                        <th className="leaderboard-stats-hide">GOAL MARKETS</th>
                                                        <th className="leaderboard-stats-hide">GOALSCORERS</th>
                                                        <th>OVERALL PTS</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {(leaderboards.leaderboards.message) ?
                                                    <tr>
                                                        <td>{leaderboards.leaderboards.message}</td>
                                                    </tr> 
                                                    : (leaderboards.leaderboards.playerStats) ?
                                                    this.setPlayerStats() 
                                                    : <tr style={{background: '#E7E7E7'}}>
                                                        <td><span className="badge badge-warning bagde-rank">
                                                            {(leaderboards.leaderboards.leaderboard.length === 1) ? 1
                                                            : (leaderboards.leaderboards.leaderboard.length === 2) ? 2
                                                            : (leaderboards.leaderboards.leaderboard.length + 1)}
                                                            </span>
                                                        </td>
                                                        <td><span className="bold">{this.cookies.get('username')}</span></td>
                                                        <td className="leaderboard-stats-hide">-</td>
                                                        <td className="leaderboard-stats-hide">-</td>
                                                        <td className="leaderboard-stats-hide">-</td>
                                                        <td>-</td>
                                                    </tr>}
                                                </tbody>
                                            </table>
                                            {(leaderboards.leaderboards.message) ? null
                                            :
                                            <table style={{ marginBottom: '30px' }}>
                                                <thead>
                                                    <tr>
                                                        <th>RANK</th>
                                                        <th className="username">USERNAME</th>
                                                        <th className="leaderboard-stats-hide">CORRECT SCORES</th>
                                                        <th className="leaderboard-stats-hide">GOAL MARKETS</th>
                                                        <th className="leaderboard-stats-hide">GOALSCORERS</th>
                                                        <th>OVERALL PTS</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.setLeaderboard()}
                                                </tbody>
                                            </table>}
                                        </div>
                                        <div style={{ float: 'right' }}>
                                            <img style={{ cursor: 'pointer' }} onClick={() => {if (this.state.selectedPage > 1) this.setState({ selectedPage: this.state.selectedPage - 1 })}} src="left-arrow.png"/>
                                            <b style={{ margin: '0 10px' }}>{'Page ' + this.state.selectedPage + ' / ' + this.state.numOfPages}</b>
                                            <img style={{ cursor: 'pointer' }} onClick={() => {if (this.state.selectedPage < this.state.numOfPages)  this.setState({ selectedPage: this.state.selectedPage + 1 })}} src="right-arrow.png"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {(this.state.popup) ? this.showPopup() : null}
                        </main>
                    </section>
                </div>
            )
        }
    }

    getRoundsNames(): JSX.Element[] {
        const rounds = Socket.Get<any>('rounds')
        const roundsNames: JSX.Element[] = []
        
        roundsNames.push(
            <li 
                key={roundsNames.length} 
                className="select2-results__option" 
                role="treeitem" 
                aria-selected={(this.state.chosenRound === 'OVERALL') ? 'true' : 'false'} 
                onClick={() => {this.changeType(null, this.state.leaderboardTypeClicked, +localStorage.getItem('leagueId')),
                                this.setState({ chosenRound: 'OVERALL', roundsDropdown: false })}}
            >
            OVERALL
            </li>
        )

        const currentTime = moment().local()
        for (let i = 0; i < rounds.rounds.length; i++) {
            const utcDeadline = moment.utc(rounds.rounds[i].deadline)
            const deadline = moment(utcDeadline).local()
            if (currentTime > deadline) {
                roundsNames.push(
                    <li 
                        key={roundsNames.length}
                        className="select2-results__option" 
                        role="treeitem" 
                        aria-selected={(this.state.chosenRound === rounds.rounds[i].roundName) ? 'true' : 'false'}
                        onClick={() => {this.changeType(rounds.rounds[i].roundId, this.state.leaderboardTypeClicked, +localStorage.getItem('leagueId')),
                                        this.setState({ chosenRound: rounds.rounds[i].roundName, roundsDropdown: false })}} 
                    >
                        {rounds.rounds[i].roundName}
                    </li>
                )
            }
        }
    
        return roundsNames
    }

    changeType(leaderboardRoundClicked: number, leaderboardTypeClicked: number, league?: number) {
        this.setState({
            leaderboardRoundClicked,
            leaderboardTypeClicked
        })
        if (localStorage.getItem('leaderboardLeagueName') === 'true') {
            if (leaderboardTypeClicked === 2) {
                Socket.Send('leaderboards', {
                                            playerId: +this.cookies.get('playerId'), 
                                            tab: +this.cookies.get('competitionTab'), 
                                            round: leaderboardRoundClicked, 
                                            nationality: (this.cookies.get('nationality'))
                                        })
            } else {
                Socket.Send('leaderboards', {
                                            playerId: +this.cookies.get('playerId'), 
                                            tab: +this.cookies.get('competitionTab'), 
                                            round: leaderboardRoundClicked})
            }
        } else {
            Socket.Send('leaderboards', {
                                        playerId: +this.cookies.get('playerId'), 
                                        tab: +this.cookies.get('competitionTab'), 
                                        league, 
                                        round: leaderboardRoundClicked})
        }
    }
    
    getUserResults(player: number) {
        this.setState({ chosenPlayer: player })
        Socket.Send('rounds', {playerId: player})
    }
    
    setLeaderboard(): JSX.Element[] {
        const leaderboardReturn: JSX.Element[] = []
        const leaderboards = Socket.Get<any>('leaderboards').leaderboards
        if (leaderboards.leaderboard) {
            const forFrom: number = (this.state.selectedPage * 10) - 10
            let forTo: number = (this.state.selectedPage * 10) - 1
            if (this.state.selectedPage === this.state.numOfPages) forTo = leaderboards.leaderboard.length - 1
            for (let i = forFrom; i <= forTo; i++) {
                leaderboardReturn.push(
                    <tr key={leaderboardReturn.length} style={(leaderboards.playerStats && leaderboards.leaderboard[i].player === leaderboards.playerStats.player) ? {background: '#E7E7E7'} : null}>
                        <td><span className="badge badge-warning bagde-rank">{leaderboards.leaderboard[i].position}</span></td>
                        <td>
                            <a href="javascript:void(0);" onClick={() => {this.getUserResults(leaderboards.leaderboard[i].playerId), this.setState({ listen: true })}}>
                                <span className="bold">{leaderboards.leaderboard[i].player}</span>
                            </a>
                        </td>
                        <td className="leaderboard-stats-hide">{leaderboards.leaderboard[i].correctScorePoints}</td>
                        <td className="leaderboard-stats-hide">{leaderboards.leaderboard[i].accumulatorPoints}</td>
                        <td className="leaderboard-stats-hide">{leaderboards.leaderboard[i].goalscorersPoints}</td>
                        <td>{leaderboards.leaderboard[i].totalPoints}</td>
                    </tr>
                )
            }
        }    
        
        return leaderboardReturn
    }
    
    setPlayerStats(): JSX.Element {
        const playerStats = Socket.Get<any>('leaderboards').leaderboards.playerStats
        return (
            <tr style={{background: '#E7E7E7'}}>
                <td><span className="badge badge-warning bagde-rank">{playerStats.position}</span></td>
                <td><span className="bold">{playerStats.player}</span></td>
                <td className="leaderboard-stats-hide">{playerStats.correctScorePoints}</td>
                <td className="leaderboard-stats-hide">{playerStats.accumulatorPoints}</td>
                <td className="leaderboard-stats-hide">{playerStats.goalscorersPoints}</td>
                <td>{playerStats.totalPoints}</td>
            </tr>
       )
    }

    showPopup() {
        const screenPosition = document.documentElement.scrollTop + 150
        const top = screenPosition.toString() + 'px'
        return (
            <div className="popup">
                <div className="popup-inner popup-forgot" style={{ top }}>
                    <div style={{ textAlign: 'right', margiemailsnBottom: '10px' }}>
                        <img 
                            src="cancel-black.png"
                            onClick={() => this.setState({ popup: false })} 
                            style={{ cursor: 'pointer' }} 
                        />
                    </div>
                    <div>
                        <p className="congratulations-third">Use the Code given below to share directly with your friends.</p>
                        <div className="congratulations-code">
                            <span>Code</span>
                            <span>{localStorage.getItem('leagueCode')}</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

withCookies(Leaderboards)
withRouter(Leaderboards)


// WEBPACK FOOTER //
// ./src/Views/Main/Index/Leaderboards.tsx